export default {

    // The variable options declared here are also declared in the config.lists.php file
    // for use in php classes etc. Remember to update any changes in both files.

    data () {
        return {
            juristicEntityTypes: [
                "Company",
                "Closed Corporation",
                "Trust",
                "Non Profit Organisation",
                "Other Juristic Entity"
            ],

            titleOptions: [
                "Mr",
                "Mrs",
                "Miss",
                "Ms",
                "Dr",
                "Sir",
                "St"
            ]
        };
    }
};